module.exports = "https://web-assets.ifttt.com/packs/media/energy_challenge/logo-midea-8bc10a4d.png";